import {Component, HostListener} from '@angular/core';
import {AnimationItem} from 'lottie-web';
import {AnimationOptions} from 'ngx-lottie';

@Component({
  selector: 'app-lottie-loader',
  templateUrl: './lottie-loader.component.html',
  styleUrls: ['./lottie-loader.component.scss']
})
export class LottieLoaderComponent {

  screenWidth: any;
  options: AnimationOptions = {
    path: './../../../../assets/animations/animation.json',
  };

  constructor() {
    this.getScreenSize();
  }

  @HostListener("window: resize", ["$event"])
  getScreenSize() {
    this.screenWidth = window.innerWidth;
  }

  animationCreated(animationItem: AnimationItem): void {
  }
}
